/**
 * A feature index's native data that answers every view of its page (News or the Library on a
 * site without a composed page): a search, sort or filter then reads it in place instead of
 * asking the server again. Only a visitor without an account reuses it, for up to five minutes,
 * as their router keeps pages; anyone signed in asks afresh, and the server never keeps it.
 */
export function reusableFeed<T extends { everyView?: boolean }>() {
  let kept: { data: T; at: number } | null = null;
  return {
    get() {
      return kept && Date.now() - kept.at < 300_000 ? kept.data : null;
    },
    keep(data: T) {
      if (typeof document === "undefined" || !data.everyView) return;
      if (document.documentElement.dataset.viewer !== "anonymous") return;
      kept = { data, at: Date.now() };
    },
  };
}
